import { isDef } from '..';
import { isNumber } from '../validate/number';
export function addUnit(value) {
  if (!isDef(value)) {
    return undefined;
  }

  value = String(value);
  return isNumber(value) ? value + "px" : value;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@2.2.16@vant/es/utils/format/unit.js
// module id = null
// module chunks = 